/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */

import parse from "html-react-parser";
import GuideImg from "../../../assets/images/guide.png";
import { FaAngleDoubleRight } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";


const CategoryDetail = ({ categoryData, HasChild, color }) => {
  const {
    CategoryName,
    CategoryDescription,
    CategoryImage,
    SubCatName,
    Image,
    BriefDescription,
    PDF,
    CategoryPDF,
  } = categoryData;
  const navigate = useNavigate();
  const { t } = useTranslation();

  if (!CategoryDescription && !BriefDescription && CategoryPDF)
    return (
      <div className="h-full w-full">
        <iframe
          onLoad={() => {}}
          width={"100%"}
          height={"100%"}
          src={"https://drive.google.com/viewerng/viewer?embedded=true&url=" + CategoryPDF}
          title="myFrame"
        />
      </div>
    );

  return (
    <div className="mt-2 overflow-y-scroll ">
      <div className="overflow-scroll w-full mx-auto  rounded-3xl">
        <img
          src={HasChild ? Image : CategoryImage}
          alt={HasChild ? Image : CategoryImage}
          className="object-contain  mx-auto"
        />
      </div>
      <p className="text-center pt-5 pb-1 text-secondary text-xl lg:mb-3 md:font-semibold">
        {HasChild ? SubCatName : CategoryName}
      </p>

      <p className=" text-sm text-black text-justify font-light md:font-normal">
        {parse(HasChild ? BriefDescription : CategoryDescription)}
      </p>

      {PDF ? (
        <div>
          <img src={GuideImg} alt="Guide" download />

          <div
            className="flex items-center justify-center"
            onClick={() =>
              navigate("/web_links", {
                state: {
                  title: CategoryName ? CategoryName : SubCatName,
                  link: PDF,
                  color: color,
                },
              })
            }
          >
            <p className="mb-10 mt-5 bg-secondary  py-2 px-5 rounded-md text-lg text-white flex items-center justify-center shadow-2xl">
              {t("GUIDE")} <FaAngleDoubleRight className="ml-1" />
            </p>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default CategoryDetail;
